import {Component, Input, OnInit, Optional} from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import {Base} from '../../../common/model/base.model';

@Component({
    selector: 'app-edit-header-layout',
    template: `

      <div *ngIf="!entity">

        <app-layout-title [title]="translationPrefix + '.create'" [isModal]="isModal">
        </app-layout-title>

        <alert type="info" *ngIf="showAlert && !isModal"> {{ translationPrefix + '.create.info' | translate }}
          <strong>{{ translationPrefix | translate }}</strong>.
        </alert>

      </div>

      <div *ngIf="entity">

        <app-layout-title [title]="translationPrefix + '.edit'" [isModal]="isModal">
        </app-layout-title>

        <alert type="info" *ngIf="showAlert && !isModal"> {{ translationPrefix + '.edit.info' | translate }}
          <strong>{{ entity.getLabel() }}</strong>.
        </alert>

      </div>

      <app-form-validation-error-layout [form]="form"></app-form-validation-error-layout>
  `,
    standalone: false
})
export class EditHeaderLayoutComponent {

  @Input() entity: Base;

  @Input() form;

  @Input() translationPrefix;

  @Input() showAlert = true;

  @Input() isModal = false;

}

